export const isOverflown = (element: Element): boolean => element.scrollWidth > element.clientWidth
